import React, { useEffect, useRef, useState } from "react";

const Textarea = ({ inputType, id, inputPlaceholder, className, rows, required, onChange, isPhoneNumber, value, handleKeyPressInput }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const inputRef = useRef(null);

    useEffect(() => {
        if (value) {
            setInputValue(value);
        }
    });
    
    const handleTextareaChange = (event) => {
        setInputValue(event.target.value);
        onChange(event.target.value); // For non-phone number inputs
    };
    
    return (
        <textarea type={inputType} placeholder={inputPlaceholder}
            className={className}
            id={id}
            onChange={handleTextareaChange}
            required={required}
            value={inputValue}
            ref={inputRef}
            rows={rows}
        ></textarea>
    );
};

export default Textarea;